import type { ProAdminRefundNotificationDto } from "@dutyon/apis";
export const notificationStatuses = {
  WAITING: "발송 대기",
  PROCESSING: "처리 중",
  RECONCILING: "접수 결과 조회 중",
  ACCEPTED: "업체 접수됨",
  NEEDS_REVIEW: "운영자 확인 필요",
  CANCELLED: "발송 제외됨",
} as const;
export function readRefundNotification(
  value: unknown,
  requestStatus: string,
): ProAdminRefundNotificationDto | null | undefined {
  if (value == null) return value;
  const fail = () => {
    throw new Error("알림 처리 기록을 확인할 수 없습니다.");
  };
  if (typeof value !== "object" || Array.isArray(value)) return fail();
  const row = value as ProAdminRefundNotificationDto;
  const iso = (input: unknown) =>
    typeof input === "string" &&
    Number.isFinite(Date.parse(input)) &&
    new Date(input).toISOString() === input;
  if (
    !["REJECTED", "CONFIRMED"].includes(requestStatus) ||
    !Object.keys(notificationStatuses).includes(row.status) ||
    Object.keys(row).some(
      (key) =>
        ![
          "status",
          "attempts",
          "failures",
          "uncertainLookups",
          "nextAttemptAt",
          "updatedAt",
        ].includes(key),
    ) ||
    [row.attempts, row.failures, row.uncertainLookups].some(
      (count) => !Number.isInteger(count) || count < 0 || count > 4,
    ) ||
    !iso(row.updatedAt) ||
    (row.nextAttemptAt !== null && !iso(row.nextAttemptAt)) ||
    (["WAITING", "RECONCILING"].includes(row.status)
      ? row.nextAttemptAt === null
      : row.nextAttemptAt !== null) ||
    (row.attempts === 0 &&
      (row.failures !== 0 ||
        row.uncertainLookups !== 0 ||
        ["ACCEPTED", "PROCESSING", "RECONCILING"].includes(row.status))) ||
    (row.status === "WAITING" && (row.failures >= 4 || row.uncertainLookups !== 0)) ||
    (row.status === "RECONCILING" && row.uncertainLookups >= 4)
  )
    return fail();
  return row;
}
